import { useEffect, useState } from 'react';

// Design System
import Form from 'jl-design-system/components/form/Form';
import { Message } from 'jl-design-system/components/message/Message';

// Types
import { PromoCodeFormProps } from './PromoCodeForm.types';

// Config
import scrollConstants from '@constants/scrollConstants';
import { scrollToElement } from '@utils/index';
import promoCodeFormConfig from '@utils/form/configs/promoCode';

// Components
import Container from '@components/container';
import RewardsPromoWarning from '@components/rewards-promo-warning/RewardsPromoWarning';

export const PromoCodeForm = ({
  handleOnChange = () => {},
  onSubmitForm,
  promoCodeError = '',
  rewardApplied = false,
}: PromoCodeFormProps) => {
  useEffect(() => {
    if (promoCodeError) scrollToElement({ id: scrollConstants.PAYMENT_TOP });
  }, [promoCodeError]);

  const [showWarningModal, setShowWarningModal] = useState<boolean>(false);
  const [promoCodeValue, setPromoCodeValue] = useState<string>('');
  const config = promoCodeFormConfig();

  const onApply = (value: string) => {
    if (rewardApplied) {
      setShowWarningModal(true);
      setPromoCodeValue(value);
      return null;
    }

    return onSubmitForm(value);
  };

  const onClose = () => setShowWarningModal(false);

  let messageProps;

  if (promoCodeError) {
    if (typeof promoCodeError === 'string') messageProps = { title: promoCodeError };
    else {
      messageProps = promoCodeError;
    }
  }

  return (
    <>
      <Container marginBottom="2" renderIf={!!promoCodeError}>
        <Message {...messageProps} type="error" />
      </Container>

      <Form
        config={config}
        data-testid="promo-code-form"
        destroyOnUnmount
        form={config?.id}
        handleOnChange={handleOnChange}
        onSubmit={onApply}
      />

      {showWarningModal && (
        <RewardsPromoWarning
          direction="promo-to-reward"
          onCancel={onClose}
          onContinue={() => {
            onSubmitForm(promoCodeValue);
            onClose();
          }}
        />
      )}
    </>
  );
};

export default PromoCodeForm;
